import { Subject } from './Subject';

/** Represents a time-boxed relationship between two objects */
export class RelationByYear {

	/** The year these relations took place */
	public year: number;

	/** The subjects who are apart of this relation during this year */
	public subjects: Subject[] = [];

	/** Creates a new instance of this object */
	constructor(init?: Partial<RelationByYear>) {
		Object.assign(this, init);
	}

}
